import { CalendarView, ViewMode } from '@insta-club/models';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

type ViewModeState = {
    mode: ViewMode;
    calendarView: CalendarView;

    // mode actions
    setMode: (mode: ViewMode) => void;
    toggleMode: () => void;
    setLegacy: () => void;
    setModern: () => void;

    // calendar actions
    setCalendarView: (view: CalendarView) => void;
    toggleCalendarView: () => void;
    setGridView: () => void;
    setSlideView: () => void;
};

export const useViewModeStore = create<ViewModeState>()(
    persist(
        (set) => ({
            mode: 'legacy',
            calendarView: 'grid',

            // mode actions
            setMode: (mode) => set({ mode }),

            toggleMode: () =>
                set((state) => ({
                    mode: state.mode === 'legacy' ? 'modern' : 'legacy'
                })),

            setLegacy: () => set({ mode: 'legacy' }),
            setModern: () => set({ mode: 'modern' }),

            // calendar actions
            setCalendarView: (view) => set({ calendarView: view }),

            toggleCalendarView: () =>
                set((state) => ({
                    calendarView: state.calendarView === 'grid' ? 'slide' : 'grid'
                })),

            setGridView: () => set({ calendarView: 'grid' }),
            setSlideView: () => set({ calendarView: 'slide' })
        }),
        {
            name: 'view-mode-storage',
            version: 2,
            storage: createJSONStorage(() => localStorage)
        }
    )
);

